import { render, staticRenderFns } from "./MainCenterBlock.vue?vue&type=template&id=d56f427a&scoped=true&"
import script from "./MainCenterBlock.vue?vue&type=script&lang=js&"
export * from "./MainCenterBlock.vue?vue&type=script&lang=js&"
import style0 from "./MainCenterBlock.vue?vue&type=style&index=0&id=d56f427a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56f427a",
  null
  
)

export default component.exports